module.exports = __webpack_public_path__ + "img/douyin.2995c208.png";